import CoachCircle from "../../components/coach-circle";
import CoachesModal from "../../components/coaches-modal";
import {throttle} from "../../helpers/utils";
import DOMHelper from "../../helpers/dom-helper";

export default class HeroSection {
    constructor() {
        this.initCoachCircle();
        this.initCoachesModal();
    }

    initCoachCircle() {
        const $coachCircle = document.getElementById('heroAbout');

        if (!$coachCircle) {
            return;
        }

        new CoachCircle($coachCircle);
    }

    initCoachesModal() {
        new CoachesModal();
    }
}